export default __webpack_public_path__ + "assets/93a8752ac2e8828772085669257f8f25.png";